export const LABELS = {
  READ_BIO: 'Read biography',
  READ_NEWS: 'Read the news',
};
